$(function() {
  if ($('body').hasClass('information-tests-page')) {
    $('.test-carousel').slick({
      dots: true,
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1
          }
        }
      ]
    });
  }
});
